import axios from "axios";
import authService from '../components/api-authorization/AuthorizeService'
/*This will be used in case our frontend is not proxying requests from the same url
const ApplicationConstants = {
    BASE_URL:
        process.env.NODE_ENV === "development"
            ? "http://developmenturl/api"
            : "https://productionurl/api",
}*/
const axiosApiInstance = axios.create({
    baseURL: '',
});

axiosApiInstance.interceptors.request.use(
    async (config : any) => {
        const token = await authService.getAccessToken();
        //const user = JSON.parse(localStorage.getItem("user"));
        if (!config.url.includes("/authentication/login")) {
            config.headers["Authorization"] = !token ? null : `Bearer ${token}`;
            config.headers["CONTENT-TYPE"] = "application/json;charset=UTF-8";
            config.headers["Accept"] = "application/json;charset=UTF-8";
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        if (error.response.status === 401) {
            //clear all localstorage items except for current view config
            let configView = localStorage.getItem("smmpviewconfig");
            localStorage.clear();
            if (configView)
            {
                localStorage.setItem("smmpviewconfig", configView);
            }
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

export default axiosApiInstance;